import React from "react";
import { Box, Flex } from "rebass/styled-components";

import { layout } from "../../../constants/constants";
import useFeatureToggle from "../../hooks/use-feature-toggle/useFeatureToggle";
import { FeatureToggle, IconPack, SingleColumnContent, TwoColumnContent } from "../../models/app-data-model";
import ContentColumn from "../content-column/content-column";
import "./two-column-block.scss";

export type TwoColumnBlockProps = {
  content: TwoColumnContent;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
  campaignPageActive?: boolean;
  modularBlock?: boolean;
};

const TwoColumnBlock: React.FC<TwoColumnBlockProps> = ({
  content,
  featureToggles,
  iconPack,
  campaignPageActive,
  modularBlock
}: TwoColumnBlockProps) => {
  const colWidth = [1, 1, 1, 1, 1 / 2];
  const colPadding = [0, 0, 0, 0, 3, 4, 4];

  const twoColMediaPriorityEnabled = useFeatureToggle("two-col-media-priority", featureToggles) || false;

  const firstColContent: SingleColumnContent = {
    content: content.first_column,
    text_alignment: content.text_alignment
  };

  const secondColContent: SingleColumnContent = {
    content: content.second_column,
    text_alignment: content.text_alignment
  };

  const firstColHasMedia = !!firstColContent.content.find((x) => x.media);
  const secondColHasMedia = !!secondColContent.content.find((x) => x.media);

  const alignItemsClass = content.vertical_alignment === "center" ? "align-items-center" : "align-items-start";
  const backgroundColor = campaignPageActive && content?.campaign_background_color ? "campaign-" + content?.campaign_background_color : "";

  const renderPaddingClass = content?.single_column_width ? "single-col-width" : "double-col-width";

  return (
    <div
      className={`${campaignPageActive ? "campaign-page-two-col" : ""} ${backgroundColor}`}
      data-testid={`${campaignPageActive ? "campaign-page-two-col_" : ""}${backgroundColor}`}
    >
      <Flex
        className={`two-col-block ${
          twoColMediaPriorityEnabled && !firstColHasMedia && secondColHasMedia && "mobile-reverse"
        } ${alignItemsClass} ${modularBlock ? renderPaddingClass : "column-width"}`}
        data-testid={
          twoColMediaPriorityEnabled && !firstColHasMedia && secondColHasMedia ? "two-col-block-mobile-reverse" : "two-col-block"
        }
        width={modularBlock ? layout.pageWidth : 1}
        marginX={"auto"}
        paddingX={layout.pagePaddingX}
      >
        <Box width={colWidth} pr={colPadding} className="first-col">
          <ContentColumn column={firstColContent} isTwoColumn={true} iconPack={iconPack} featureToggles={featureToggles} />
        </Box>
        <Box width={colWidth} pl={colPadding} className="second-col">
          <ContentColumn column={secondColContent} isTwoColumn={true} iconPack={iconPack} featureToggles={featureToggles} />
        </Box>
      </Flex>
    </div>
  );
};

export default TwoColumnBlock;
